let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("qX7kz")).then(() => parcelRequire('bw4v7'));